import React, { useState, useEffect } from 'react'
import styled, { css } from 'styled-components'
import { useLocation, useHistory } from 'react-router-dom';
import Header from "../Header";
import { colors } from '../../styles'
import twitter from '../../assets/images/twitter.png'
import telegram from '../../assets/images/telegram.png'
import wallet from '../../assets/images/wallet.png'
import { Twitter, Discord } from './SocialLinkArea'

interface MenuAreaProps {
    displayMenu: boolean;
    connected: boolean,
    address: string,
    chainId: number,
    killSession: () => void,
    openModal: () => void,
}

interface MenuContainerProps {
    status: boolean;
}
interface MenuItemProps {
    isActive: string;
    current: string;
}

const MenuContainer = styled.ul<MenuContainerProps>`
    display: flex;
    flex-direction: row;
    align-items: center;
    transition: all 0.3s ease-in-out;
    width: 100%;
    max-width: 500px;
    justify-content: space-between;
    @media (max-width: 960px) {
        max-width: 90%;
        flex-direction: column;
        transform: translateY(${props => props.status ? '-100%' : '30%'});
        background: rgba(${colors.main}, 1);
        width: 100%;
        position: absolute;
        z-index: 10;
        border-radius: 20px;
        border: 1px solid rgba(${colors.border});
    }
`
const MmenuItem = styled.li<MenuItemProps>`
    color: rgb(${colors.fontColor});
    font-size: 20px;
    font-family: "NexaDemo-Light";
    margin: 0 1em;
    border-bottom: ${props =>
        props.current === props.isActive
            ? `3px solid rgb(${colors.main})`
            : '3px solid transparent'
    };

    @media (max-width: 960px) {
        margin: 0.5em 0;
    }
    &:hover {
        cursor: pointer;
        border-bottom: 3px solid rgb(${colors.main})
    }
`
const SocialIcon = styled.img`
    width: 16px;
`

const MenuArea: React.FC<MenuAreaProps> = ({
    killSession,
    openModal,
    displayMenu,
    connected,
    address,
    chainId,
}) => {
    const [isActive, setIsActive] = useState("")
    const location = useLocation();
    useEffect(() => {
        setIsActive(location.pathname)
    }, [location.pathname])

    let history = useHistory()
    const navigateTo = (targetPath: string) => {
        history.push(`/${targetPath}`)
    }
    const smoothScroll = () => {
        document.querySelector('#team')?.scrollIntoView({
            behavior: 'smooth'
        });
    }
    return (
        <MenuContainer status={displayMenu}>
            <MmenuItem onClick={() => navigateTo("")} isActive={isActive} current="/">MINT</MmenuItem>
            <MmenuItem onClick={() => navigateTo("")} isActive={isActive} current="/staking">STAKING</MmenuItem>
            <MmenuItem onClick={() => navigateTo("roadmap")} isActive={isActive} current="/roadmap">ROADMAP</MmenuItem>
            <MmenuItem onClick={() => smoothScroll()} isActive={isActive} current="/team">TEAM</MmenuItem>
            {/* {
                connected &&
                <Header
                    connected={connected}
                    address={address}
                    chainId={chainId}
                    killSession={killSession}
                />
            } */}
            {!displayMenu &&
                <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
                    <Twitter>
                        <SocialIcon src={twitter} />
                    </Twitter>
                    <Discord>
                        <SocialIcon src={telegram} />
                    </Discord>
                </div>}
        </MenuContainer>
    )
}

export default MenuArea
